import { StyleSheet } from 'react-native'
import { ProgressBar } from '../../../ProgressBar'
import { useEffect, useState } from 'react'
import { DS } from '../../../../../design-system'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

type TimerProps = {
  secondsPassed: number
}

const Timer = ({ secondsPassed }: TimerProps) => {
  const [timeLeft, setTimeLeft] = useState(Math.floor(secondsPassed / 1000))

  useEffect(() => {
    const interval = setInterval(() => {
      if (timeLeft > 0) {
        setTimeLeft(timeLeft - 1)
      }
    }, 1000)
    return () => clearInterval(interval)
  }, [timeLeft])

  return (
    <DS.Frame row>
      <DS.Text variant="Caption/Bold" uppercase>
        Next hand in
      </DS.Text>
      <DS.Text variant="Caption/Bold" style={styles.item}>
        {timeLeft}s
      </DS.Text>
    </DS.Frame>
  )
}

export interface TimerShowCardsProps {
  durationSeconds: number
  showNextHandIn: boolean
  isShowCards?: boolean
}

export const TimerShowCards = ({ showNextHandIn, durationSeconds, isShowCards = false }: TimerShowCardsProps) => {
  const insets = useSafeAreaInsets()
  //TODO: why subtracting - 1s ?
  const secondsPassed = durationSeconds * 1000 - 1000

  return (
    <DS.Frame style={[styles.container, isShowCards ? { marginBottom: insets.bottom } : styles.containerBorder]}>
      {showNextHandIn ? (
        <DS.Frame style={styles.timer}>
          <Timer secondsPassed={secondsPassed} />
        </DS.Frame>
      ) : null}
      <DS.Frame style={styles.progressBar}>
        <ProgressBar
          height={5}
          duration={secondsPassed}
          maxDuration={durationSeconds * 1000}
          backgroundColor={'Global/Black'}
          backgroundOpacity={0.1}
          color={'Brand/Orange'}
        />
      </DS.Frame>
    </DS.Frame>
  )
}

const styles = StyleSheet.create({
  container: {
    flexShrink: 1,
    flexDirection: 'row'
  },
  containerBorder: {
    alignContent: 'center',
    justifyContent: 'center',
    borderTopWidth: 1,
    borderBottomWidth: 1,
    minHeight: 38,
    borderColor: DS.palette['Brand/Light Grey']
  },
  timer: {
    alignContent: 'center',
    justifyContent: 'center'
  },
  progressBar: {
    flex: 1,
    alignContent: 'center',
    justifyContent: 'center',
    marginLeft: DS.spacing['16']
  },
  errorContainer: {
    width: '100%',
    alignItems: 'center',
    height: 12
  },
  item: {
    marginLeft: 5
  }
})
